export default __webpack_public_path__ + "static/media/outlineHeart.1b56fc19.svg";